import { render, staticRenderFns } from "./onboarding-step-indicator.vue?vue&type=template&id=3a6fc5eb&scoped=true&"
import script from "./onboarding-step-indicator.vue?vue&type=script&lang=js&"
export * from "./onboarding-step-indicator.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-step-indicator.vue?vue&type=style&index=0&id=3a6fc5eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6fc5eb",
  null
  
)

export default component.exports